import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const REFEREE_POST_REQUEST = 'POST_REFEREE_REQUEST';
export const REFEREE_POST_FAILURE = 'POST_REFEREE_FAILURE';
export const REFEREE_POST_SUCCESS = 'POST_REFEREE_SUCCESS';

export const postReferee = (data) => {
    return function(dispatch) {
        dispatch(postRequest());
        return axios(apiRequestOptions(apiPath.REFEREE.POST, data))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(postSuccess(response.data));
                dispatch(addSuccessMessage('Referee successfully added'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRequest = () => {
    return { type: REFEREE_POST_REQUEST }
};

const postFailure = error => {
    return { type: REFEREE_POST_FAILURE, error }
};

const postSuccess = referee => {
    return { type: REFEREE_POST_SUCCESS, referee }
};